// extracted by mini-css-extract-plugin
export default {"path":"Path_path__hglR5","path-details":"Path_path-details__VXYCa","path--active":"Path_path--active__s0WAD"};